module.exports = __webpack_public_path__ + "media/images/front/life_style/1-ce67d1b754813c27d8a63873b25f1a99.jpg";